import {
  ChangeDetectorRef,
  Component,
  effect,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbcLoginComponent } from '@barthauer/abc/core/authentication';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'basys-authentication-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LoginComponent {
  @ViewChild('abcLoginComponent') abcLoginComponent: AbcLoginComponent;

  @Input() showResetPassword: boolean = false;
  @Input() showRegistration: boolean = false;
  @Input() useCustomLoader = false;
  @Input() twoFaIssuer: string;

  @Output() logoClick = new EventEmitter<void>();

  public needsPasswordChange: boolean = false;
  public showForgotPasswordView: boolean = false;

  public res = ResourceSet.Empty;

  public readonly fallbackLogo = 'assets/resources/basys-core-authentication/BaSYS_logo.svg';
  public readonly fallbackIllustration = 'assets/resources/basys-core-authentication/BaSYS_Login_Illustration.png';
  public readonly fallbackCornerLogo = 'assets/resources/basys-core-authentication/BARTHAUER_software_RGB.png';
  public logo: string = this.fallbackLogo;
  public cornerLogo: string = this.fallbackCornerLogo;
  public illustration: string = this.fallbackIllustration;

  protected isMobileVersion: boolean = false;

  constructor(
    private config: AbcConfigService,
    private activatedRoute: ActivatedRoute,
    private resourceService: ResourceManagerService,
    private changeDetectorRef: ChangeDetectorRef,
    private host: ElementRef<HTMLElement>
  ) {
    effect(async () => {
      const routeData = await firstValueFrom(this.activatedRoute.data);
      this.res = await this.resourceService.getResourceSet('basys-core-authentication');

      const loginConfig = this.config.configuration.Style?.Login;

      this.logo = loginConfig?.Logo ?? routeData?.Logo ?? this.res.svgUrl('Logo-Image') ?? this.fallbackLogo;

      this.cornerLogo =
        loginConfig?.CornerLogo ??
        routeData?.CornerLogo ??
        this.res.svgUrl('CornerLogo-Image') ??
        this.fallbackCornerLogo;

      this.host.nativeElement.style.setProperty(
        '--corner-logo-image',
        this.cornerLogo ? `url('${this.cornerLogo}')` : 'none'
      );

      this.illustration =
        loginConfig?.Illustration ??
        routeData?.Illustration ??
        this.res.svgUrl('Loginscreen-Image') ??
        this.fallbackIllustration;

      if (loginConfig?.BackgroundColor) {
        document.documentElement?.style?.setProperty(
          '--login-container-controls-background-color',
          loginConfig.BackgroundColor
        );
      }
    });
  }

  ngOnInit(): void {
    const w = typeof window !== 'undefined' ? (window as any) : undefined;
    if (w?.cordova) {
      this.isMobileVersion = true;
      return;
    }

    if (typeof document !== 'undefined') {
      document.addEventListener(
        'deviceready',
        () => {
          this.isMobileVersion = true;
          this.changeDetectorRef.markForCheck();
        },
        { once: true }
      );
    }
  }

  public onLogoClick(): void {
    this.logoClick.emit();
  }
}
